/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AIModelExportRequest
 */
export interface AIModelExportRequest {
    /**
     * 
     * @type {string}
     * @memberof AIModelExportRequest
     */
    path: string;
}

export function AIModelExportRequestFromJSON(json: any): AIModelExportRequest {
    return AIModelExportRequestFromJSONTyped(json, false);
}

export function AIModelExportRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AIModelExportRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'path': json['path'],
    };
}

export function AIModelExportRequestToJSON(value?: AIModelExportRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'path': value.path,
    };
}


